import type { Catalog } from "../../en";

/** Filipino: Inbox (mirrors en/engage/inbox.ts). */
export const inbox: Catalog["engage"]["inbox"] = {
  title: "Inbox",
  live: "Live",
  connecting: "Kumokonekta…",
  reconnecting: "Kumokonekta ulit…",
  liveHint: "Kusang lumalabas dito ang mga bagong usapan at reply.",
  views: {
    label: "Mga view",
    all: "Lahat",
    needs_staff: "Kailangan ng staff",
    mine: "Naka-assign sa akin",
    my_teams: "Mga team ko",
    ai_resolved: "Nalutas ng AI",
    leads: "Mga lead",
    snoozed: "Naka-snooze",
    closed: "Sarado",
  },
  snooze: {
    until: "Naka-snooze hanggang {{when}}",
    heading: "Naka-snooze",
    wakes: "Babalik sa {{when}}, o kapag sumagot ang customer o isang kasamahan.",
    unsnooze: "I-unsnooze",
    woken: "Hindi na naka-snooze ang usapan",
    emptyTitle: "Walang naka-snooze",
    emptyBody: "Puwedeng i-snooze ng workflow ang isang usapan hanggang sa takdang oras. Dito ito maghihintay, at babalik kapag tapos na ang oras o kapag sumagot ang customer o isang kasamahan.",
  },
  search: "Hanapin ang pangalan, mensahe, tag…",
  filters: {
    open: "I-filter",
    openActive_one: "I-filter ({{count}} aktibo)",
    openActive_other: "I-filter ({{count}} aktibo)",
    heading: "I-filter ang mga usapan",
    channel: "Channel",
    agent: "Agent",
    team: "Team",
    anyTeam: "Anumang team",
    tag: "Tag",
    anyTag: "Kahit anong tag",
    date: "Petsa",
    priority: "Priority",
    anyPriority: "Anumang priority",
    sort: "Pagkakasunod",
    sorts: { recent: "Pinakabago muna", priority: "Priority muna" },
    ranges: { any: "Kahit kailan", today: "Ngayong araw", "7d": "Huling 7 araw", "30d": "Huling 30 araw" },
    reset: "I-reset",
    apply: "Ilapat",
  },
  priority: {
    label: "Priority",
    normal: "Normal",
    high: "Mataas",
    urgent: "Madalian",
    changed: "Itinakda ang priority sa {{priority}}",
  },
  language: {
    other: "Ibang wika: {{name}}",
    hint: "Nakasulat sa {{name}}. Hindi ito sinasalita ng assistant: sasagot ito sa English maliban kung may piniling wika para sa usapang ito.",
    names: { ceb: "Cebuano", ilo: "Ilokano", hil: "Hiligaynon", zh: "Tsino" },
  },
  sla: {
    dueIn: "Due sa loob ng {{time}}",
    breached: "Nalampasan",
    stages: { first_response: "Unang tugon", next_response: "Susunod na tugon", resolution: "Paglutas" },
  },
  rating: {
    title: "Rating ng customer",
    outOf: "{{rating}} sa {{max}}",
    up: "Thumbs up",
    down: "Thumbs down",
    ratedAt: "Na-rate noong {{time}}",
  },
  list: {
    label: "Mga usapan",
    shown: "{{shown}} sa {{total}} sa view na ito",
    shownOpen: "{{shown}} ang ipinapakita",
    loadOlder: "Mag-load ng mas luma",
    unread: "Hindi pa nababasa",
    verified: "Verified",
    ai: "AI",
    staff: "Staff · {{name}}",
    team: "Team",
    emptyTitle: "Walang laman ang view na ito",
    emptyBody: "Subukan ang ibang view o i-clear ang paghahanap.",
    clearSearch: "I-clear ang paghahanap at filter",
    loadError: "Hindi ma-load ang mga usapan.",
  },
  status: {
    label: "Status",
    needsStaff: "Kailangan ng staff",
    open: "Bukas",
    waiting: "Naghihintay",
    resolved: "Nalutas",
    closed: "Sarado",
    abandoned: "Iniwan",
    lead: "Lead",
    changed: "Minarkahan ang usapan bilang {{status}}",
  },
  thread: {
    back: "Bumalik sa listahan",
    started: "Nagsimula {{time}}",
    assign: "I-assign",
    assignTo: "I-assign kay",
    assignedTo: "Naka-assign kay {{name}}",
    assignedToast: "Na-assign kay {{name}}",
    you: "Ikaw",
    unassign: "Alisin ang assignment",
    teamRoundRobin: "{{team}} (round-robin)",
    takeOver: "Akuin mula sa AI",
    returnToAi: "Ibalik sa AI",
    tookOver: "Inako mo — naka-pause ang AI sa usapang ito",
    returned: "Ibinalik sa AI — sasagutin ng assistant ang mga bagong mensahe",
    toggleDetails: "Ipakita o itago ang detalye",
    selectTitle: "Pumili ng usapan",
    selectBody: "Pumili ng usapan sa listahan para mabasa at masagot ito.",
    loadError: "Hindi ma-load ang usapang ito.",
    today: "Ngayon · {{date}}",
    messagesLabel: "Mga mensahe",
    aiMeta: "AI",
    seconds: "{{value}}s",
    sources_one: "{{count}} source",
    sources_other: "{{count}} source",
    confidence: "kumpiyansa {{value}}",
    staffMeta: "{{name}} · Staff",
    delivered: "Naihatid",
    queued: "Ipinapadala…",
    outsideWindow: "Hindi naihatid — lampas na sa 24 oras na palugit",
    noteHeading: "Internal note — staff lang ang makakakita · {{name}} · {{time}}",
    labelledNoteHeading: "{{label}} — staff lang ang makakakita · {{name}} · {{time}}",
    staffMember: "Staff",
    citationFallback: "Source {{n}}",
    location: "p.{{page}}",
  },
  events: {
    handoff_requested: "Humiling ng staff · {{time}}",
    handoffReason: "Humiling ng staff: {{reason}} · {{time}}",
    escalated: "Ipinaalam sa Owner — walang kumuha sa oras · {{time}}",
    assigned: "Na-assign kay {{name}} · {{time}}",
    unassigned: "Inalis ang assignment · {{time}}",
    status_changed: "Pinalitan ang status sa {{status}} · {{time}}",
    takeover: "Inako ni {{name}} — naka-pause ang AI · {{time}}",
    released: "Ibinalik sa AI · {{time}}",
    returned_to_queue: "Ibinalik sa pila ng team · {{time}}",
    contact_captured: "Nag-iwan ng email ang bisita · {{time}}",
    added_to_knowledge: "Na-save sa knowledge base · {{time}}",
    rated: "Ni-rate ng bisita ang usapan · {{time}}",
    snoozed: "Na-snooze ng workflow na “{{workflow}}” ang usapang ito hanggang {{when}} · {{time}}",
    snoozedPlain: "Naka-snooze hanggang {{when}} · {{time}}",
    snoozedNoTime: "Na-snooze ang usapan · {{time}}",
    unsnoozed: {
      timer: "Tapos na ang snooze: dumating na ang oras · {{time}}",
      visitor_reply: "Tapos na ang snooze: sumagot ang customer · {{time}}",
      staff_reply: "Tapos na ang snooze: sumagot ang isang kasamahan · {{time}}",
      closed: "Tapos na ang snooze: isinara ang usapan · {{time}}",
    },
    unsnoozedBy: "Inalis ni {{name}} ang snooze · {{time}}",
    someone: "Isang kasamahan",
    reasons: {
      asked_for_person: "gustong makausap ang tao",
      knowledge_gap: "walang sagot sa knowledge base",
      low_confidence: "mababa ang kumpiyansa ng sagot",
      payment: "tanong sa bayad",
      negative_sentiment: "mukhang nadismaya ang bisita",
      keyword: "keyword ng escalation",
      other: "iba pa",
    },
  },
  handoff: {
    title: "Handoff",
    titleReason: "Handoff: {{reason}}",
    waiting: "Naghihintay ng staff",
    outOfHours: "Sarado ang opisina",
    routedTo: "Ipinasa sa",
    teamQueue: "Pila ng {{team}} team",
    ownersAndAdmins: "Owner at mga Admin",
    visitorEmail: "Email ng bisita",
    aiSummary: "Buod ng AI",
    autoSummary: "Buod mula sa mga salita ng bisita",
  },
  composer: {
    tabs: "Uri ng mensahe",
    reply: "Reply",
    note: "Internal note",
    replyingOn: "Sumasagot sa {{channel}} bilang",
    staffOnly: "Staff lang ang makakakita",
    locked: "Ang AI ang humahawak sa chat na ito. Akuin para sumagot bilang staff, o mag-iwan ng internal note.",
    replyPlaceholder: "Mag-type ng reply…  (Enter para ipadala, Shift+Enter para sa bagong linya)",
    notePlaceholder: "Sumulat ng internal note — staff lang ang makakakita. Gamitin ang @ para i-mention ang kasamahan.",
    label: "Mensahe",
    savedReplies: "Mga saved reply",
    noSavedReplies: "Wala pang saved reply",
    draftWithAi: "Mag-draft gamit ang AI",
    drafting: "Gumagawa ng draft…",
    draftReady: "Handa na ang draft — suriin bago ipadala",
    draftFailed: "Hindi makagawa ng draft ang AI sa ngayon.",
    send: "Ipadala",
    addNote: "Idagdag ang note",
    sent: "Naipadala ang reply",
    noteAdded: "Naidagdag ang internal note",
    empty: "Sumulat muna ng mensahe",
    sendFailed: "Hindi naipadala ang reply mo. Pakisubukang muli.",
    enterToSend: "ipadala",
    readOnly: "Mababasa mo ang usapang ito pero hindi ka makakasagot.",
    messengerPause: "Kapag sumagot sa Messenger, naka-pause ang assistant nang 12 oras.",
  },
  details: {
    title: "Detalye",
    close: "Isara ang detalye",
    identity: "Pagkakakilanlan",
    channel: "Channel",
    location: "Lokasyon",
    device: "Device",
    firstSeen: "Unang nakita",
    language: "Wika",
    page: "Pahina",
    verified: "Verified",
    notVerified: "hindi verified",
    maskedId: "ID",
    identityTypes: {
      anonymous: "Anonymous · cookie ID",
      lead_otp: "Na-verify sa one-time code",
      messenger: "Messenger profile",
      sso: "Single sign-on",
      jwt: "Naka-sign in na user",
      email: "Email address",
    },
    lead: "Nakuhang lead",
    openLead: "Buksan ang lead",
    mobile: "Mobile",
    email: "Email",
    interest: "Interes",
    stage: "Stage",
    tags: "Mga tag",
    addTag: "Magdagdag ng tag…",
    removeTag: "Alisin ang tag na {{tag}}",
    tagAdded: "Naidagdag ang tag",
    tagRemoved: "Naalis ang tag",
    messages: "Mga mensahe",
    confidence: "Avg na kumpiyansa",
    sla: "Handoff SLA",
    slaWaiting: "Naghihintay {{time}}",
    slaReplied: "Sinagot sa {{time}}",
    slaNone: "Walang handoff",
    slaOverdue: "Lampas {{minutes}} min",
    slaEscalated: "Naabisuhan ang Owner at mga Admin",
    sourcesUsed: "Mga source na ginamit",
    noSources: "Wala pang nabanggit na source",
    previous: "Mga naunang usapan",
    noPrevious: "Unang usapan sa bisitang ito",
    handledByAi: "AI",
    handledByStaff: "Staff",
    untitled: "Usapan",
    actionsTaken: "Mga ginawang action",
    noActions: "Walang action na tumakbo sa usapang ito",
    actionStatus: "{{status}} · {{ms}} ms",
    addToKnowledge: "Idagdag sa Knowledge",
    exportTranscript: "I-export ang transcript",
    exported: "Na-export ang transcript · {{file}}",
  },
  knowledge: {
    title: "Idagdag sa Knowledge",
    description: "I-save ang sagot na ito bilang Q&A source. Gagamitin ito ng assistant sa mga katulad na tanong.",
    question: "Tanong",
    questionPlaceholder: "Ano ang itinanong ng bisita?",
    answer: "Sagot",
    audiences: "Sino ang makakakita ng sagot",
    save: "I-save bilang Q&A source",
    saved: "Na-save ang reply ng staff bilang Q&A source · gagamitin na ito ng AI",
    questionRequired: "Ilagay ang tanong na sinasagot nito",
    answerRequired: "Ilagay ang sagot",
    audienceRequired: "Pumili ng kahit isang audience",
    nothing: "Wala pang reply sa usapang ito na mase-save.",
  },
  shortcuts: {
    title: "Mga keyboard shortcut",
    next: "Susunod na usapan",
    previous: "Naunang usapan",
    reply: "Sumagot",
    resolve: "Lutasin",
    resolved: "Nalutas ang usapan",
  },
};
